<div [hidden]="!active" class="tab-pane directory-tab-container">
    <div class="panel-body">
        <ng-content></ng-content>
    </div>
</div>




// WEBPACK FOOTER //
// /app/src/app/components/tabs/tab-item/tab-item.component.html